import moment from "moment";

export const COLUMNS =[
    {
        Header      : '#',
        accessor    : 'ID',
        Cell: props => <span key={props.value}>{props.value}</span>,
        disableFilters:true
    },
    {
        Header      : 'Email Subject',
        accessor    : 'subject',

        Cell: (row) => {
            /* Add data-tip */
            return <span data-tip={row.value}>{row.value.length >15 ?row.value.slice(0,14)+"..." :row.value}</span>;
          }
    },
    {
        Header      : 'Email Sent to',
        accessor    : 'clientEmailId',
        // disableFilters:true
    },
    {
        Header      : 'Date and Time',
        // accessor    :  moment('createdAt').format("DD-MMM-YYYY")  ,
        accessor: d => {
            if(d.createdAt === ""){
                return <span>-</span>
            }
            else{
                return moment(d.createdAt)
                .format("DD-MM-YYYY hh:mm:ss a")
            }
         
          }
        
     
    },
    {
        Header      : 'Category',
        accessor    : 'category',
        // Cell            : e=><div className="text-center"><a href={'/'+(localStorage.getItem('role') === 'admin' ? 'admin' : 'user')+'/view/contractreview/'+(e.value).split("-")[1]}> {'View'} </a></div>,
        // disableFilters:true
    },
   
    {
        Header      : 'Client Name',
        accessor    : 'orgName',
        // Cell        : e=><div className="text-center"><a href={'/'+(localStorage.getItem('role') === 'admin' ? 'admin' : 'user')+'/view/viewauditagreements/'+(e.value).split("-")[1]}> {'View'} </a></div>,
        // disableFilters:true
    },
    // {
    //     Header      : 'Remark',
    //     accessor    : 'auditteamlist',
    //     Cell        : e=><div className="text-center"><a href={'/'+(localStorage.getItem('role') === 'admin' ? 'admin' : 'user')+'/viewauditteamproposal/'+(e.value).split("-")[1]}> {'View'} </a></div>,
    //     disableFilters:true
    // },
   
]